const getConstraints = () => ({
	'name': {
		presence: {allowEmpty: false},
	}
});

module.exports = {
	getConstraints
};
